import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="frontend--lightbox"
// Opens a gallery photo full size in a dialog. Without JS the link still opens
// the image itself, so the gallery keeps working.
export default class extends Controller {
  static values = { caption: String, alt: String }

  open(event) {
    event.preventDefault()
    this.dialog = this.#buildDialog(this.element.href, this.captionValue, this.altValue)
    document.body.appendChild(this.dialog)
    this.dialog.showModal()
    this.dialog.addEventListener("close", () => this.dialog.remove(), { once: true })
  }

  disconnect() {
    if (this.dialog?.open) this.dialog.close()
  }

  #buildDialog(href, caption, alt) {
    const dialog = document.createElement("dialog")
    dialog.className = "lightbox"
    dialog.setAttribute("aria-label", caption || "Foto")

    const image = document.createElement("img")
    image.src = href
    // A caption is not a description: an image described but not captioned must
    // keep its own alt text when enlarged.
    image.alt = alt || ""
    dialog.appendChild(image)

    if (caption) {
      const text = document.createElement("p")
      text.textContent = caption
      dialog.appendChild(text)
    }

    const close = document.createElement("button")
    close.type = "button"
    close.className = "lightbox-close"
    close.setAttribute("aria-label", "Sluiten")
    close.textContent = "×"
    close.addEventListener("click", () => dialog.close())
    dialog.appendChild(close)

    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close()
    })

    return dialog
  }
}
